import {
	ResponsiveContainer,
	XAxis,
	YAxis,
	ZAxis,
	ScatterChart,
	Scatter,
	Label,
	LabelList,
	ReferenceLine,
	Tooltip,
} from "recharts";
import React, { useState, useEffect } from "react";
import { numberFormatter } from "../../utils";
const GrossMarginChart2 = (props: any) => {
	const [data, setData] = useState([]);
	const { selectedMaskStatus, supplier, selectedVendor } = props;
	const refX = props?.performanceGraphData?.weightedNiaPcnt * 100;
	const refY = props?.performanceGraphData?.weightedGM * 100;
	useEffect(() => {
		if (props?.performanceGraphData) {
			setData(props.performanceGraphData?.peer);
		}
	}, [props]);

	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "fit-content",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				color: "black",
				padding: 0,
			};

			return (
				<div style={popupStyle}>
					{/* Header Row */}
					<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">Supplier:</div>
						<div
							className="font-bold ml-1"
							style={{ color: "#3f3f3f" }}
						>
							{data.peer_vendor_name}
						</div>
					</div>
					{/* Data Rows */}
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Spend:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.invCost, 0, "$")}
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Last Year NIA% of Spend:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.rebate_base_lastyear, 0)}%
							</label>
						</p>
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Last Year Gross Margin %:{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.gm, 0)}%
							</label>
						</p>
					</div>
				</div>
			);
		}
		return null;
	};

	console.log(selectedVendor, "sel");
	return (
		<div className="w-full flex flex-col items-center h-[80%] ">
			<ResponsiveContainer width="100%" height="100%">
				<ScatterChart
					width={400}
					height={400}
					data={data}
					margin={{
						top: 30,
						right: 70,
						bottom: 10,
						left: 30,
					}}
				>
					<XAxis
						className="graph-label "
						stroke="black"
						type="number"
						dataKey="rebate_base_lastyear"
						tickFormatter={(val) => `${numberFormatter(val, 0)}%`}
						domain={["dataMin - 5", "dataMax + 5"]}
					>
						<Label
							value="Last Year NIA% of Spend"
							offset={-1}
							position="bottom"
							style={{ fill: "black" }}
						/>
					</XAxis>
					<YAxis
						className="graph-label"
						stroke="black"
						type="number"
						dataKey="gm"
						interval={0}
						tickFormatter={(val) => `${numberFormatter(val, 0)}%`}
						domain={["dataMin - 5", "dataMax + 5"]}
					>
						<Label
							value={`LYGM%​`}
							angle={-90}
							offset={0}
							position="insideLeft"
							style={{ fill: "black", textAnchor: "middle" }}
						/>
					</YAxis>
					<ZAxis
						type="number"
						range={data?.length <= 10 ? [350, 350] : [350, 350]}
					></ZAxis>
					<ReferenceLine
						x={refX}
						label={{
							position: "top",
							fill: "#ce9178",
							value: numberFormatter(refX, 2) + "%",
							fontStyle: "italic",
							className: 'textMedium'
						}}
						stroke="black"
						strokeDasharray="5 3"
						opacity={0.3}
					/>
					<ReferenceLine
						y={refY}
						label={{
							position: "right",
							fill: "#ce9178",
							value: numberFormatter(refY, 2) + "%",
							fontStyle: "italic",
							className: 'textMedium'
						}}
						stroke="black"
						strokeDasharray="5 3"
						opacity={0.3}
					/>
					<Tooltip
						contentStyle={{
							color: "black",
							backgroundColor: "rgb(26, 25, 22)",
						}}
						cursor={{ strokeDasharray: "3 3", fill: "#f1f1f1" }}
						content={customTooltip}
					/>
					{data?.map((d: any, index: number) => {
						return (
							<>
								{supplier?.includes(d?.peer_vendor_name) && (
									<Scatter
										key={index}
										data={[d]}
										fill={
											d?.peer_vendor_name ===
											selectedVendor?.master_vendor_name
												? "#62B5E582" // New blue color with alpha
												: "#EAA61482" // New yellow color with alpha
										}
									>
										{!selectedMaskStatus && (
											<LabelList
												dataKey="peer_vendor_name"
												fill="black"
												className="graph-label-xsmall "
												position={"right"}
											/>
										)}
									</Scatter>
								)}
							</>
						);
					})}
				</ScatterChart>
			</ResponsiveContainer>
		</div>
	);
};
export default GrossMarginChart2;
